import ConfigService from '../../../shared/configService';
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import detaildashboard_en from "../../../translations/en/detaildashboard.json";

interface IProps {
    rbList: any[],
    openTabEvent: any

}
i18next.init({
    interpolation: { escapeValue: false },
    lng: 'en',
    resources: {
        en: {

            detaildashboard: detaildashboard_en
        }
    },
});


export const SectionInterventionTypesList = (props: IProps) => {
    const { t } = useTranslation('dashboard');
    return (

        <div className="interventionTypesList">
            {
                props.rbList.map((oneRB: any, i: number) => (
                    <>
                        <div>
                            <div className={`collapsabel__item ${i == 0 ? "open" : (i > 4 ? "hidden":"")}`}>
                                <button type="button" className="collapsabel__item__header" onClick={() => props.openTabEvent(i, 'divAreaofLand')}>
                                    {oneRB[ConfigService.getConfig().agol.operationalLayers.reportRb.fields.name_2] && <span className="nameSpan" key={i}>{oneRB[ConfigService.getConfig().agol.operationalLayers.reportRb.fields.name_2]}</span>}
                                    {oneRB[ConfigService.getConfig().agol.operationalLayers.reportRb.fields.name_1] && !oneRB[ConfigService.getConfig().agol.operationalLayers.reportRb.fields.name_2] && <span className="nameSpan" key={i}>{oneRB[ConfigService.getConfig().agol.operationalLayers.reportRb.fields.name_1]}</span>}
                                    {!oneRB[ConfigService.getConfig().agol.operationalLayers.reportRb.fields.name_1] && !oneRB[ConfigService.getConfig().agol.operationalLayers.reportRb.fields.name_2] && <span className="nameSpan" key={i}>{oneRB[ConfigService.getConfig().agol.operationalLayers.reportRb.fields.name_0]}</span>}


                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.225 13.615">
                                        <path d="m26.11 2.115-11.719 10-12.281-10" fill="none" stroke="#197058" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                                    </svg>
                                </button>
                            </div>
                            <div className={`collapsabel__item__body ${i == 0 ? "heightAutoAccordion" : "heightAccordion" }`}>
                                <div className="alignwide">
                                    <div>
                                        <p><strong>Implementation start year: </strong><span className="normaltxt">{oneRB.ha_imp_year}</span></p>
                                        <p><strong>Tier: </strong><span className="normaltxt">{oneRB.ha_tier}</span> </p>
                                        <div className="two-column-info-content-container">
                                            <div className="two-column-info-content">
                                                {
                                                     oneRB.ha_intervention_types_values && oneRB.ha_intervention_types_values.length > 0 &&
                                                     oneRB.ha_intervention_types_values.sort().map((interv: string, j: number) => (
                                                    <>
                                                    <div className="arealandrow">
                                                        <div className="image-badge">
                                                            <div className="image-wrapper">
                                                                <img className="imgPlaceHolder" ></img>
                                                            </div>
                                                            <div className="text-content">
                                                       
                                                                <div>
                                                                    
                                                                <span> <strong>{interv}</strong></span>
                                                                        
                                                                </div>
                                                               

                                                            </div>
                                                        </div>
                                                        <div className="col-6 listDiv">
                                                           <strong>Intervention: </strong>
                                                        </div>
                                                        <div className="col-6 listDiv">
                                                        <span className="normaltxt">{oneRB.ha_information[j]}</span>
                                                        </div>
                                                    </div>
                                                        <br/>
                                                    </>
                                                   ))
                                                }
                                                
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                ))
            }
        </div>

    )
}

export default SectionInterventionTypesList;